import { Component, OnInit } from '@angular/core';
import { Order } from '../../models';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { BaseOnDestroyComponent } from '../../../shared/injectables/BaseOnDestroy.component';

@Component({
  selector: 'app-missing-data-copy-widget',
  styleUrls: ['./missing-data-copy-widget.component.scss'],
  template: `
    <div class="wrapper  p-y--8">
      <div class="widget card">
        <div class="widget_header ps-1">
          <span>
            <button mat-icon-button (click)="loadData()">
              <mat-icon>autorenew</mat-icon>
            </button>
            Datenkopie fehlt
          </span>
        </div>
        <app-orders-list-for-widget
          [indicatorStyleFn]="getCircleColor"
          [states]="states"
        ></app-orders-list-for-widget>
      </div>
    </div>
  `
})
export class MissingDataCopyWidgetComponent extends BaseOnDestroyComponent
  implements OnInit {
  states: string[];

  constructor(private store$: Store<ApplicationState>) {
    super();
  }

  ngOnInit(): void {
    this.states = ['copy_data'];
  }

  loadData(): void {
    this.states = [...this.states];
  }

  getCircleColor(order: Order): { [key: string]: string } {
    return { backgroundColor: '#ffc400' };
  }
}
